// 10 = ciclo interrompido, 16 = excluído
const IGNORED_EXCEPTION_TYPES = [10, 16];

// O fim de um código é o início do próximo código do mesmo equipamento que não seja
// interrompido/excluído, assim a duração não muda ao ocultar esses ciclos.
// Retorna um Map id_code -> { end_id, end_timestamp }.
export const getValidEndByCodeId = (list) => {
  const nextValidEndByEquip = new Map();
  const validEndByCodeId = new Map();

  [...list]
    .sort((a, b) => b.timestamp_op - a.timestamp_op)
    .forEach((code) => {
      const isIgnored = IGNORED_EXCEPTION_TYPES.includes(code.exception_type);
      const nextEnd = nextValidEndByEquip.get(code.equip_id);

      validEndByCodeId.set(code.id_code, nextEnd || {
        end_id: code.end_id,
        end_timestamp: code.end_timestamp,
      });

      if (!isIgnored) {
        nextValidEndByEquip.set(code.equip_id, {
          end_id: code.id_code,
          end_timestamp: code.timestamp_op,
        });
      } else if (!nextEnd) {
        // Último código do equipamento na lista é ignorado: o fim vem do backend
        nextValidEndByEquip.set(code.equip_id, validEndByCodeId.get(code.id_code));
      }
    });

  return validEndByCodeId;
};

export default getValidEndByCodeId;
